import { RequiredType } from './RequirePermissions';

const hasPermissions = (
  userPermissions: readonly string[],
  requiredPermissions: string[],
  permissionsType?: RequiredType,
) => {
  if (permissionsType === 'all') {
    return requiredPermissions.every((permission) =>
      userPermissions.includes(permission),
    );
  }
  return requiredPermissions.some((permission) =>
    userPermissions.includes(permission),
  );
};

export default hasPermissions;
